import { useOrg } from '../components/OrgContext';
import { homeKindFor } from './company';

// A screen for pure agents only (redesign step 5; dev website only: App.tsx uses it only when the release switch is on). Everyone else gets `legacy` (today's page, or a redirect).
export default function AgentGate({ page, legacy }) {
  const { capabilities } = useOrg();
  return homeKindFor(capabilities) === 'agent' ? page : legacy;
}
